import withAdminLayout from "components/HoC/withAdminLayout";
import ConditionPage from "pages/admin/setting/ConditionPage";
import ConfigActionPage from "pages/admin/setting/ConfigActionPage";
import ConfigRequest from "pages/admin/setting/ConfigRequest";
import DepartmentPage from "pages/admin/setting/DepartmentPage";
import HolidaysPage from "pages/admin/setting/HolidaysPage";
import KPIPage from "pages/admin/setting/KPIPage";
import ManageActionPage from "pages/admin/setting/ManageActionPage";
import PermissionPage from "pages/admin/setting/PermissionPage";
import PersonalPage from "pages/admin/setting/PersonalPage";
import RolePage from "pages/admin/setting/RolePage";
import SurrogatePage from "pages/admin/setting/SurrogatePage";
import TransferJobPage from "pages/admin/setting/TransferJobPage";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";
import EmployeePage from "pages/admin/setting/EmployeePage";
import ConfigSmartServicedPage from "pages/admin/setting/ConfigSmartServicedPage";
import EmployeeDetailPage from "pages/admin/setting/EmployeeDetailPage";

function SettingPage() {
  const { t, i18n } = useTranslation();

  return (
    <Switch>
      <Route path="/admin/setting/department">
        <DepartmentPage />
      </Route>
      <Route path="/admin/setting/condition">
        <ConditionPage />
      </Route>
      <Route path="/admin/setting/kpi">
        <KPIPage />
      </Route>
      <Route path="/admin/setting/holidays">
        <HolidaysPage />
      </Route>
      <Route path="/admin/setting/configsmartservice">
        <ConfigSmartServicedPage />
      </Route>
      <Route path="/admin/setting/manage-user">
        <EmployeePage />
      </Route>
      <Route path="/admin/setting/role">
        <RolePage />
      </Route>
      <Route path="/admin/setting/config-action">
        <ConfigActionPage />
      </Route>
      <Route path="/admin/setting/manage-action">
        <ManageActionPage />
      </Route>
      {/* <Route path="/admin/setting/personal">
        <PersonalPage />
      </Route> */}
      <Route path="/admin/setting/employee/:empId">
        <EmployeeDetailPage />
      </Route>
      <Route path="/admin/setting/surrogate">
        <SurrogatePage />
      </Route>
      <Route path="/admin/setting/config-request">
        <ConfigRequest />
      </Route>
      <Route path="/admin/setting/transfer-job">
        <TransferJobPage />
      </Route>
      <Route path="/admin/setting/permission">
        <PermissionPage />
      </Route>

    </Switch>
  );
}

export default withAdminLayout(SettingPage);
